const BUCKET_NAME = 'devices';

export default class ThingTypeController {
    /** @ngInject */
    constructor(EventEmitter, ThingsService) {
        this.eventEmitter = EventEmitter;
        this.ThingsService = ThingsService;
    }

    $onInit() {
        this.types = [];
        this.things = this.ThingsService.getAllThings();
        this.typesMap = {};
        this.typesRulesMap = {};
        this.createTypesMap();
        this.createTypesRulesMap();
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    createTypesMap() {
        this.things.forEach((thing) => {
            this.typesMap[thing.type] = false;
        });
    }

    createTypesRulesMap() {
        this.things.forEach((thing) => {
            if (thing.rules && thing.rules.items && thing.rules.items.length) {
                const value = {};

                this.typesRulesMap[thing.type] = value;

                thing.rules.items.forEach((rule) => {
                    if (rule.items) {
                        rule.items.forEach((subrule) => {
                            value[subrule.name] = {
                                value: rule.type === 'input' ? '' : false
                            };
                            value[subrule.name].defaultValue = value[subrule.name].value;
                        });
                    } else {
                        value[rule.name] = {
                            value: rule.type === 'input' ? '' : false
                        };
                        value[rule.name].defaultValue = value[rule.name].value;
                    }
                });
            }
        });
    }

    toggle(thing) {
        const currentState = this.typesMap[thing.type] || false;
        const newState = !currentState;

        if (!newState) {
            const typesLength = this.types.length;

            for (let i = 0; i < typesLength; ++i) {
                if (this.types[i].type === thing.type) {
                    this.types.splice(i, 1);
                    break;
                }
            }
        } else {
            this.types.push({ type: thing.type });
        }

        this.typesMap[thing.type] = newState;
        this.onChange();
    }

    parseValueFormat(format) { // eslint-disable-line class-methods-use-this
        return format.replace('%s', '').trim();
    }

    onChange() {
        const thingTypes = this.getThingTypes();

        if (thingTypes.length) {
            this.fillBucket(thingTypes);

            this.pushUpdate(
                this.eventEmitter({
                    value: thingTypes
                })
            );
        } else {
            this.clearBucket();
        }
    }

    getThingTypes() {
        if (!this.types.length) {
            return [];
        }

        const types = [];

        this.types.forEach((thing) => {
            if (thing.type in this.typesMap && this.typesMap[thing.type] === true) {
                const thingType = {
                    type: thing.type
                };

                if (thing.type in this.typesRulesMap) {
                    const rules = this.typesRulesMap[thing.type];
                    Object.keys(rules).forEach((ruleName) => {
                        if (rules[ruleName].value === true || rules[ruleName].value.length) {
                            if (!('state' in thingType)) {
                                thingType.state = {};
                            }
                            thingType.state[ruleName] = rules[ruleName].value;
                        }
                    });
                }

                types.push(thingType);
            }
        });

        return types;
    }

    fillBucket(thingTypes) {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: thingTypes || this.getThingTypes()
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.types = [];
        this.typesMap = {};
        this.typesRulesMap = {};
        this.createTypesMap();
        this.createTypesRulesMap();

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-type/thing-type.controller.js